import * as React from 'react';

import { Button } from '@cian/button-component';
import { trackSetAppClick, trackSetAppPopupClose } from './tracking';

import * as style from './style.css';
import { CloseIcon } from '../components/close_icon';

const SETUP_APP_URL = 'https://www.cian.ru/mobile/#rec34693210';

export interface ISetupAppPopupProps {
  onCancel: React.MouseEventHandler<HTMLElement>;
  onClose: React.MouseEventHandler<HTMLElement>;
}

export class SetupAppPopup extends React.Component<ISetupAppPopupProps> {
  private handleSetAppClick = (event: React.MouseEvent<HTMLElement>) => {
    trackSetAppClick();
    window.location.href = SETUP_APP_URL;
  };

  private closePopup = (event: React.MouseEvent<HTMLElement>) => {
    trackSetAppPopupClose();
    this.props.onClose(event);
  };

  public render() {
    return (
      <div className={style['moderation-constraint-popup']}>
        <div className={style['moderation-constraint-popup_container']}>
          <div className={style['moderation-constraint-popup_button-close']} onClick={this.closePopup}>
            <CloseIcon />
          </div>
          <p className={style['moderation-constraint-popup_title']}>Установите приложение ЦИАН</p>
          <p className={style['moderation-constraint-popup_text']}>
            Чтобы пройти проверку, необходимо установить мобильное приложение и войти в свой аккаунт.
          </p>
          <Button
            onClick={this.handleSetAppClick}
            className={style['moderation-constraint-popup_button-accept']}
            theme="default"
          >
            Установить приложение
          </Button>
        </div>
      </div>
    );
  }
}
